import type { SVGProps } from 'react';

const SvgFire = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      stroke="#000"
      strokeWidth={1.5}
      d="M13.752 3.172c-.002-.076-.085-.126-.15-.087-3.466 2.07-3.402 7.264-3.36 8.205.003.071-.064.121-.129.09-.4-.188-1.547-.898-1.61-2.865-.003-.076-.085-.125-.15-.086C6.345 9.618 5 11.814 5 14.25 5 17.978 8.134 21 12 21s7-3.022 7-6.75c0-5.416-5.12-6.58-5.248-11.078Z"
    />
  </svg>
);
export default SvgFire;
